export default class {

    // @ngInject
    constructor($routeParams, authService, responseHandler, nextDispatcher) {
        this.$routeParams = $routeParams;
        this.authService = authService;
        this.responseHandler = responseHandler;
        this.nextDispatcher = nextDispatcher;
        this.isQuickLogout = this.$routeParams.type === 'quick';
        if (this.isQuickLogout) {
            this.logout();
        }
    }

    stayLoggedIn() {
        this.nextDispatcher();
    }

    logout() {
        this.responseHandler(this.authService.logout())
            .finally(() => this.nextDispatcher());
    }
}



// WEBPACK FOOTER //
// ./logout/logout-ctrl.js